import SeoLandingPage from '../SeoLandingPage';

const config = {
  seoKey: 'singing',
  eyebrow: 'Singing Classes in Milton Keynes',
  h1: 'Singing Classes',
  h1Accent: 'in Milton Keynes',
  intro:
    'Build a powerful, healthy singing voice in Milton Keynes. UPA singing classes cover technique, pitch, harmony and performance — perfect for musical theatre, choir, auditions or pure love of singing. Ages 4–18, all levels welcome.',
  heroImage:
    'https://customer-assets.emergentagent.com/job_class-manager-84/artifacts/33mkqy5l_j-Bethaney-Never-Enough-006.JPG',
  bullets: [
    {
      title: 'Healthy vocal technique',
      body: 'Breath, resonance, mix and belt taught the right way — protecting young voices for the long term.',
    },
    {
      title: 'Musical theatre repertoire',
      body: 'Build a song book from the West End and Broadway canon, plus contemporary pop where it fits.',
    },
    {
      title: 'Harmony & Show Choir',
      body: 'Ensemble singing, harmony stacking and the social joy of singing together.',
    },
    {
      title: 'Stage performance',
      body: 'Termly showcases turn weekly practice into real live audience experience.',
    },
  ],
  whatYouLearn: [
    { title: 'Breath & Support', body: 'The engine of every great voice — taught carefully so young singers thrive.' },
    { title: 'Pitch & Ear Training', body: 'Hit the note. Hold the note. Hear the harmony.' },
    { title: 'Belting & Mix', body: 'Powerful, contemporary musical theatre sound without strain.' },
    { title: 'Harmony', body: 'Two-, three- and four-part harmonies in our Show Choir setting.' },
    { title: 'Microphone Technique', body: 'Stage mics, head mics, distance, dynamics and proximity effect.' },
    { title: 'Audition Songs', body: 'Choosing, learning and performing audition material that actually lands.' },
  ],
  ageGroups: [
    { ageRange: '4–6', label: 'Mini Stars' },
    { ageRange: '7–10', label: 'Juniors' },
    { ageRange: '11–14', label: 'Inters' },
    { ageRange: '15–18', label: 'Seniors' },
  ],
  relatedLinks: [
    { label: 'Musical Theatre Classes Milton Keynes', to: '/musical-theatre-classes-milton-keynes' },
    { label: 'Acting Classes Milton Keynes', to: '/acting-classes-milton-keynes' },
    { label: 'Dance Classes Milton Keynes', to: '/dance-classes-milton-keynes' },
    { label: 'UPA Show Choir', to: '/show-choir' },
    { label: 'View the Class Timetable', to: '/schedule' },
    { label: 'Book a Free Trial', to: '/free-trial' },
  ],
};

const SingingMK = () => <SeoLandingPage config={config} />;
export default SingingMK;
